module.exports = __webpack_public_path__ + "img/top-2-2.c76ed8dd.png";